module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMCAxOTJhMzIgMzIgMCAwIDAtMzEuOCAyOC4zTDQ4MCAyODh2MTkySDI4OGEzMiAzMiAwIDAgMC0zLjcgNjMuOEwyODggNTQ0aDE5MnYxOTJhMzIgMzIgMCAwIDAgNjMuOCAzLjdMNTQ0IDczNnYtMTkyaDE5MmEzMiAzMiAwIDAgMCAzLjctNjMuOEw3MzYgNDgwaC0xOTJWMjg4YTMyIDMyIDAgMCAwLTMyLTMyeiIgZmlsbD0iIzAiIHAtaWQ9IjMyMDUiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Add-filled.svg
// module id = yjqX
// module chunks = 74